import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Chip,
  Grid,
} from "@mui/material";
import { Phone, Email } from "@mui/icons-material";

export default function InfoNotification({ open, onClose, NotificationData }) {
  // Safety check
  if (!NotificationData) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Notification Log Info</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 1 }}>
          {/* Notification Message */}
          <Box
            sx={{
              p: 2,
              bgcolor: "grey.900",
              color: "white",
              borderRadius: 1.5,
              borderLeft: "4px solid #1976d2", // MUI primary blue
              boxShadow: "0 2px 6px rgba(0,0,0,0.4)",
            }}
          >
            <Typography variant="body1" sx={{ fontWeight: 500 }}>
              {NotificationData.notification}
            </Typography>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ mt: 1, display: "block" }}
            >
              {new Date(NotificationData.time).toLocaleString()}
            </Typography>
          </Box>

          {/* Recipients Lists */}
          <Grid container spacing={3}>
            {/* Phone Recipients */}
            <Grid item xs={12} md={6} sx={{overflow:"auto", height:"61vh", width:"48%", pr: 2}}>
              <Box sx={{ pr: 1 }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Phone color="primary" />
                  <Typography variant="h6">
                    Phone Recipients ({NotificationData.recipientsLength || 0})
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {NotificationData.phoneList &&
                  NotificationData.phoneList.length > 0 ? (
                    NotificationData.phoneList.map((phone, index) => (
                      <Chip
                        key={index}
                        label={phone}
                        variant="outlined"
                        color="primary"
                        icon={<Phone />}
                        sx={{ justifyContent: "flex-start" }}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No phone recipients
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
            {/* Email Recipients */}
            <Grid item xs={12} md={6} sx={{overflow:"auto",height:"61vh",width:"48%", pr: 2}}>
              <Box sx={{ pr: 1 }}>
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <Email color="white" />
                  <Typography variant="h6">
                    Email Recipients ({NotificationData.emailsLength || 0})
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {NotificationData.emailList &&
                  NotificationData.emailList.length > 0 ? (
                    NotificationData.emailList.map((email, index) => (
                      <Chip
                        key={index}
                        label={email}
                        variant="outlined"
                        color="white"
                        icon={<Email />}
                        sx={{ justifyContent: "flex-start" }}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      No email recipients
                    </Typography>
                  )}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
